const icons = {};

icons.proceduralContext = <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect width="24" height="24" fill="white" />
  <path d="M4 4H6V6H4V4Z" fill="#D93562" />
  <path d="M4 18H6V20H4V18Z" fill="#D93562" />
  <path d="M8.5 4H10.5V6H8.5V4Z" fill="#D93562" />
  <path d="M8.5 18H10.5V20H8.5V18Z" fill="#D93562" />
  <path d="M13.5 4H15.5V6H13.5V4Z" fill="#D93562" />
  <path d="M13.5 18H15.5V20H13.5V18Z" fill="#D93562" />
  <path d="M18 4H20V6H18V4Z" fill="#D93562" />
  <path d="M18 18H20V20H18V18Z" fill="#D93562" />
  <path d="M18 10.5V8.5H20V10.5H18Z" fill="#D93562" />
  <path d="M4 15.5L4 13.5H6V15.5H4Z" fill="#D93562" />
  <path d="M7.25 11H2.25L4.75 8.5L7.25 11Z" fill="#D93562" />
  <path d="M16.75 13H21.75L19.25 15.5L16.75 13Z" fill="#D93562" />
</svg>



export default icons;